

// import React, { useContext } from "react";
// import { Link } from "react-router-dom";
// import { LanguageContext } from "../Components/LanguageContext";
// // import css from "./RunningCard.module.css";
// import css from "../Modulecss/Home.module.css";

// export default function RunningCard({ runnig, winnAmount, game_type }) {
//   const user = localStorage.getItem("userId");

//   // Language translations
//   const translations = {
//     hi: {
//       view: "देखे",
//       prize: "Winning Prize",
//       entry: "Entry Fee",
//     },
//     en: {
//       view: "view",
//       entry: "Entry Fee",
//       prize: "Winning Prize",
//     },
//   };

//   const { language } = useContext(LanguageContext);

//   const creatorName =
//     runnig?.Created_by?.Name?.length > 7
//       ? `${runnig.Created_by.Name.slice(0, 7)}...`
//       : runnig?.Created_by?.Name;

//   const acceptorName =
//     runnig?.Accepetd_By?.Name?.length > 7
//       ? `${runnig.Accepetd_By.Name.slice(0, 7)}...`
//       : runnig?.Accepetd_By?.Name;

//   return (
//     <div className={css.runningBattleCard}>
//       {/* Top Header Bar */}
//       <div className={css.runningCardHeader}>
//         <span className={css.gamePlayTitle}>
//           Game Play between <strong className={css.playerName}>{creatorName}</strong> &{" "}
//           <strong className={css.playerName}>{acceptorName}</strong>
//         </span>
//       </div>

//       {/* Main Card Body */}
//       <div className={css.runningCardBody}>
//         {/* Entry Fee Section */}
//         <div className={`${css.feeColumn} ${css.left}`}>
//           <span className={css.feeLabel}>{translations[language]?.entry || "Entry Fee"}</span>
//           <div className={css.feeAmountRow}>
//             <img src="/images/moneyrupee.png" alt="cash" className={css.cashIcon} />
//             <span className={css.feeAmount}>{runnig?.Game_Ammount}</span>
//           </div>
//         </div>

//         {/* Center Versus or View Button */}
//         <div className={css.centerActionCol}>
//           {user === runnig?.Accepetd_By?._id || user === runnig?.Created_by?._id ? (
//             <Link
//               className={`${css.btnViewMatch} ${
//                 runnig?.Status === "conflict" ? css.conflict : css.active
//               }`}
//               to={{
//                 pathname: `/viewgame1/${runnig?._id}`,
//                 state: { prevPath: window.location.pathname },
//               }}
//             >
//               {translations[language]?.view || "view"}
//             </Link>
//           ) : (
//             <div className={css.vsBadgeWrapper}>
//               <img
//                 className={css.vsIcon}
//                 src={process.env.PUBLIC_URL + "/images/versus.png"}
//                 alt="VS"
//               />
//             </div>
//           )}
//         </div>

//         {/* Winning Prize Section */}
//         <div className={`${css.feeColumn} ${css.right}`}>
//           <span className={css.feeLabel}>{translations[language]?.prize || "Winning Prize"}</span>
//           <div className={`${css.feeAmountRow} ${css.justifyEnd}`}>
//             <img src="/images/moneyrupee.png" alt="cash" className={css.cashIcon} />
//             <span className={css.feeAmount}>
//               {runnig?.Game_Ammount + winnAmount(runnig?.Game_Ammount)}
//             </span>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }




import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { LanguageContext } from "../Components/LanguageContext";
// import css from "../Modulecss/RunningCard.module.css";
import css from "../Modulecss/Home.module.css"

export default function RunningCard({ runnig, winnAmount, game_type }) {
  const user = localStorage.getItem("userId");

  // Existing language translations
  const translations = {
    hi: {
      view: "देखे",
      prize: "Winning Prize",
      entry: "Entry Fee",
    },
    en: {
      view: "view",
      entry: "Entry Fee",
      prize: "Winning Prize",
    },
  };

  const { language } = useContext(LanguageContext);

  const creatorName =
    runnig?.Created_by?.Name?.length > 7
      ? `${runnig.Created_by.Name.slice(0, 7)}...`
      : runnig?.Created_by?.Name;

  const acceptorName =
    runnig?.Accepetd_By?.Name?.length > 7
      ? `${runnig.Accepetd_By.Name.slice(0, 7)}...`
      : runnig?.Accepetd_By?.Name;

  return (
    <div className={css.runningBattleCard}>
      {/* Existing player header */}
      <div className={css.runningCardHeader}>
        <span className={css.gamePlayTitle}>
          Game Play between{" "}
          <strong className={css.playerName}>
            {creatorName}
          </strong>{" "}
          &{" "}
          <strong className={css.playerName}>
            {acceptorName}
          </strong>
        </span>
      </div>

      {/* Entry fee, VS / View, winning prize */}
      <div className={css.runningCardBody}>
        {/* Entry Fee */}
        <div className={`${css.feeColumn} ${css.left}`}>
          <span className={css.feeLabel}>
            {translations[language]?.entry || "Entry Fee"}
          </span>

          <div className={css.feeAmountRow}>
            <img
              src="/images/moneyrupee.png"
              alt="cash"
              className={css.cashIcon}
            />

            <span className={css.feeAmount}>
              {runnig?.Game_Ammount}
            </span>
          </div>
        </div>

        {/* Existing VS / View condition */}
        <div className={css.centerActionCol}>
          {user === runnig?.Accepetd_By?._id ||
          user === runnig?.Created_by?._id ? (
            <Link
              className={`${css.btnViewMatch} ${
                runnig?.Status === "conflict"
                  ? css.conflict
                  : css.active
              }`}
              to={{
                pathname: `/viewgame1/${runnig?._id}`,
                state: {
                  prevPath: window.location.pathname,
                },
              }}
            >
              {translations[language]?.view || "view"}
            </Link>
          ) : (
            <div className={css.vsBadgeWrapper}>
              <img
                className={css.vsIcon}
                src={process.env.PUBLIC_URL + "/images/versus.png"}
                alt="VS"
              />
            </div>
          )}
        </div>

        {/* Winning Prize */}
        <div className={`${css.feeColumn} ${css.right}`}>
          <span className={css.feeLabel}>
            {translations[language]?.prize || "Winning Prize"}
          </span>

          <div className={`${css.feeAmountRow} ${css.justifyEnd}`}>
            <img
              src="/images/moneyrupee.png"
              alt="cash"
              className={css.cashIcon}
            />

            <span className={css.feeAmount}>
              {runnig?.Game_Ammount +
                winnAmount(runnig?.Game_Ammount)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
